export default __webpack_public_path__ + "static/media/notify.4c5148e6.svg";